import * as React from 'react'
import * as domain from '@packages/domain'
import styled from 'styled-components'
import { constVoid, E, identity, O, pipe, RA, s, tt } from '@packages/prelude'
import { react } from '../commons'
import { CategoryTitle } from '../components/CategoryTitle'
import { BasePost } from './BasePost'

export interface PostProps {
  post: domain.Post.Type
}
const Description = styled.div`
  margin-bottom: 1rem;

  &,
  & > p {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  & > p {
    margin-bottom: 0;
  }
`

const TagList = styled.div`
  > span {
    display: inline-block;
    color: var(--bs-primary);
    font-weight: 700;
    font-style: italic;
    &::before {
      content: '#';
    }
  }
`

export const Post: React.VFC<PostProps> = ({ post }) => {
  const icon = pipe(
    post.primaryCategory.icon,
    E.fromOption(constVoid),
    E.chainW(tt.NonEmptyString.decode),
    E.foldMap(s.Monoid)(identity)
  )
  return (
    <BasePost post={post} title={<CategoryTitle name={post.primaryCategory.name} icon={icon} />}>
      {pipe(
        post.subtitle,
        O.foldMap(react.monoid)(subtitle => <h3 className="h4">{subtitle}</h3>)
      )}
      {pipe(
        post.description,
        O.foldMap(react.monoid)(description => <Description dangerouslySetInnerHTML={{ __html: description }} />)
      )}
      <TagList>
        {pipe(
          post.categories,
          RA.foldMap(react.monoid)(category => <span className="me-2">{category.name}</span>)
        )}
        {pipe(
          post.tags,
          RA.foldMap(react.monoid)(tag => (
            <span className="me-2" key={tag.name}>
              {tag.name}
            </span>
          ))
        )}
      </TagList>
    </BasePost>
  )
}
